import $ from "jquery";
import "datatables.net";
import "datatables.net-dt";

export default function initObjectsTable() {
  $(document).ready(function () {
    const table = $(".objects-table").DataTable({
      paging: false,
      searching: false,
      scrollX: true,
      aoColumnDefs: [
        // { sClass: "dt_hide_col", aTargets: [0] },
        { iDataSort: 0, aTargets: [1] },
      ],
      drawCallback: function (settings) {
        triggerObjectsOnImage();

        $(".apartment").on("mouseenter touchstart", function () {
          const id = $(this).attr("id");

          $(".objects-table tr[data-id='" + id + "']").addClass("rowHover");
        });

        $(".apartment").on("mouseleave touchend", function () {
          const id = $(this).attr("id");

          $(".objects-table tr[data-id='" + id + "']").removeClass("rowHover");
        });
      },
    });

    table.columns([0]).visible(false, false);
    table.columns.adjust().draw(false); // adjust column sizing and redraw

    table.on("click", "tbody tr", function () {
      // if apartment is not sold
      if ($(this).attr("data-status") !== "sold") {
        window.location.href = $(this).attr("data-url");
      }
    });

    // -----------------------------------------//
    function triggerObjectsOnImage() {
      const tableRows = document.querySelectorAll(".objects-table tbody tr");

      tableRows.forEach((row) => {
        $(row)
          .off("mouseenter")
          .on("mouseenter", function () {
            const rowID = row.dataset.id;
            const object = document.querySelector(`.apartment[id=${rowID}]`);

            object.classList.add("active");
          });
      });

      tableRows.forEach((row) => {
        $(row)
          .off("mouseleave")
          .on("mouseleave", function () {
            const rowID = row.dataset.id;
            const object = document.querySelector(`.apartment[id=${rowID}]`);

            object.classList.remove("active");
          });
      });
    }

    // -----------------------------------------//

    function triggerClickFromApartmentSVG() {
      const items = document.querySelectorAll(".apartment");

      items.forEach((item) => {
        item.addEventListener("click", function () {
          const id = item.getAttribute("id");
          const tableRow = document.querySelector(`tr[data-id=${id}]`);

          if (tableRow !== null) {
            tableRow.click();
          }
        });
      });
    }

    triggerClickFromApartmentSVG();
  });
}
